// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hexN8rGKDAQ3W8qD{text-align:center}.FP8V2Tk_GMgNnP8F{display:flex;justify-content:center;column-gap:8px}.ZR38YwrzzVUJEglJ{color:var(--py-danger-9);display:flex;column-gap:4px}.dH3PHmottU6BDxwb{display:flex;column-gap:2px}.dH3PHmottU6BDxwb .tphC0VaeGKMqzvjq{padding:2px;font-size:9px;align-self:flex-start;color:var(--py-primary-9);opacity:.7}.dH3PHmottU6BDxwb .tphC0VaeGKMqzvjq:hover{opacity:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `hexN8rGKDAQ3W8qD`,
	"actionButtons": `FP8V2Tk_GMgNnP8F`,
	"errorText": `ZR38YwrzzVUJEglJ`,
	"quesitonStatusTitle": `dH3PHmottU6BDxwb`,
	"questionStatusTooltip": `tphC0VaeGKMqzvjq`
};
export default ___CSS_LOADER_EXPORT___;
